enum BillingsTaxiUnbilledOrderListingItemStatus {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export default BillingsTaxiUnbilledOrderListingItemStatus;
